import { Box } from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../../../i18n';
import { ErrorLouiseOffer } from '../../../../../../../../types/Quotes';
import QuoteErrorMessage from '../../../../../components/default/QuoteErrorMessage';

interface Props {
  offer: ErrorLouiseOffer;
}

const SingleOfferErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
}) => {
  return (
    <Box mx={{ base: '2', laptop: '6' }}>
      <QuoteErrorMessage
        httpCode={offer.code}
        message={handleResponseLanguage(offer.errorMessage)}
      />
    </Box>
  );
};

export default SingleOfferErrorMessage;
